import { useExperimentFlag } from './useExperimentFlag';

export const useExperimentDiscountLadder = (): boolean => useExperimentFlag('enable_discount_ladder', 'exp');
